import { useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ListenNow from './components/ListenNow';
import About from './components/About';
import Programming from './components/Programming';
import Blog from './components/Blog';
import Community from './components/Community';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { updateSEO, cleanupStructuredData } from '../../lib/seo';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://ranchfireradio.com';
    
    updateSEO({
      title: 'RanchFire Radio - Rooted. Real. Country.',
      description: 'Authentic Texas Country, Red Dirt & Tex-Mex Country Music broadcasting from the heart of Texas. Experience real country music that stays true to its roots.',
      keywords: 'Texas Country Music, Red Dirt Music, Tex-Mex Country, Country Radio, Texas Radio, Authentic Country',
      canonical: '/',
      ogImage: 'https://static.readdy.ai/image/f407d1ad302e1be1c54e67247a4ef201/1d2b59dfb9c0bc727c9fa79ffa1643de.png',
      structuredData: {
        "@context": "https://schema.org",
        "@type": "RadioStation",
        "name": "RanchFire Radio",
        "description": "Authentic Texas Country, Red Dirt & Tex-Mex Country Music broadcasting from the heart of Texas",
        "url": siteUrl,
        "logo": "https://static.readdy.ai/image/f407d1ad302e1be1c54e67247a4ef201/1d2b59dfb9c0bc727c9fa79ffa1643de.png",
        "sameAs": [
          "https://www.instagram.com/ranchfire_radio/"
        ],
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "TX",
          "addressCountry": "US"
        },
        "genre": ["Texas Country", "Red Dirt", "Tex-Mex Country", "Americana"],
        "broadcastFrequency": "Online Streaming",
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "info@ranchfireradio.com",
          "contactType": "Customer Service"
        }
      }
    });

    return () => {
      cleanupStructuredData();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ListenNow />
      <About />
      <Programming />
      <Blog />
      <Community />
      <Contact />
      <Footer />
    </div>
  );
}
